/**
 * guards/MentorRoute.jsx
 * Allows only mentors and admins. Redirects users to /dashboard,
 * unauthenticated users to /.
 */
import { Navigate } from "react-router-dom";

export default function MentorRoute({ user, role, children }) {
  if (!user) return <Navigate to="/" replace />;
  if (role === "mentor" || role === "admin") return children;
  // Regular user tried to access mentor page
  return <Navigate to="/dashboard" replace />;
}